<template>
	<div>
		<v-header></v-header>
		<van-swipe class="my-swipe" v-if="!this.$store.state.translate" :autoplay="3000" indicator-color="white">
			<van-swipe-item>
				<img src="../assets/images/banner_01.jpg">
			</van-swipe-item>
		</van-swipe>
		<van-swipe class="my-swipe" v-if="this.$store.state.translate" :autoplay="3000" indicator-color="white">
			<van-swipe-item>
				<img src="../assets/images/b1_01.jpg">
			</van-swipe-item>
		</van-swipe>
		<!--  -->
		<div class="qbj">
			<div class="g-yx m-padding" id="Appointment">
				<div class="m-box">
					<div class="m-c">
						<div class="tit  wow bounceInUp" data-wow-delay="0.1s">
							<img src="../assets/images/timg_03.png">
							<h1 class="p34">{{ $t('indexyx.1') }}</h1>
							<img src="../assets/images/timg_03.png">
							<div class="p20 pp">{{ $t('indexyx.2') }}</div>
						</div>
						<div class="c-c">
							<div class="c-l  wow bounceInUp" data-wow-delay="0.2s">
								<div class="f-f p20">
									<input type="text" v-model="$store.state.user.homedata.invite_url" id="copylink"
										value="http://********" readonly="readonly" disabled />
									<div class="b-img" @click="copy" id="copy">

									</div>
								</div>
								<div class="f-f p20">
									<input type="text" id="yy" :value="$store.state.user.homedata.pay + 'USDT'" disabled/>
									<button @click="pay" >{{ $t('indexyx.3') }}</button>
								</div>
								<div class="f-f p20" style="justify-content: unset;">
									{{ $t('indexzs.19') }}：{{toFloor( $store.state.wallet.balance.usdt) }} USDT
									
								</div>
								<div class="p28">{{ $t('indexyx.4') }}</div>
								<div style="display: flex;flex-direction: column;align-items: center;">
									<div class="g-l p18" style="width: 100%;">
										<div class="s-l">
											<div class="p-h">{{ $t('indexyx.5') }}</div>
											<div class="p-h1">{{ $t('indexyx.6') }}</div>
										</div>
										<ul v-if="$store.state.user.list.rows">
											<li v-for="(item, i) in $store.state.user.list.rows" :key="i">
												<div class="p-h">{{ item.self_performance }}</div>
												<div class="p-h1">{{ item.nickname }}</div>
											</li>

										</ul>

									</div>

									<van-pagination @change="changePage" v-model="currentPage"
										:total-items="$store.state.user.list.total"
										:page-count="$store.state.user.list.lastPage" :show-page-size="6"
										force-ellipses>
										<template #prev-text>
											<van-icon name="arrow-left" />
										</template>
										<template #next-text>
											<van-icon name="arrow" />
										</template>
										<template #page="{ text }">{{ text }}</template>
									</van-pagination>
								</div>
								<br>
							</div>
							<div class="c-r  wow bounceInUp" data-wow-delay="0.3s">
								<div class="p34 h-h">
									Valla phone<br>
									{{ $t('indexyx.7') }}
								</div>
								<div class="p20 pt">{{ $t('indexyx.8') }}</div>
								<div class="p34 p-s">
									{{ $t('indexyx.9') }}<b>2028</b>{{ $t('indexyx.10') }}<br>
									<b>DePIN</b>{{ $t('indexyx.11') }}<br>
									{{ $t('indexyx.12') }}<b>3.5{{ $t('indexyx.13') }}</b>{{ $t('indexyx.14') }}
								</div>
								<div class="p18">{{ $t('indexyx.15') }}</div>
							</div>
						</div>
					</div>
				</div>
				<!-- <div class="m-box" style="margin-top: 2rem;"  id="Mine">
					<div class="m-c">
						<div class="tit  wow bounceInUp" data-wow-delay="0.1s">
							<img src="../assets/images/timg_03.png">
							<h1 class="p34">{{ $t('indexzs.8') }}</h1>
							<img src="../assets/images/timg_03.png">
					
						</div>
						<div class="f1">VAL {{ $t('indexzs.25') }}：<span class="f2">{{$store.state.user.awardData.price}}USDT</span></div>
						<div class="c-c">
							<div class="c-l  wow bounceInUp" data-wow-delay="0.2s" style="width: 100%;">
								<div class="f-f p20" style="justify-content: unset;">
									{{ $t('indexzs.9') }}
									<input type="text" style="width: 33%;margin-left: 1rem;"  id="copylink" disabled
										:value=" $t('indexzs.10') +'('+$store.state.user.awardData.recommend+')'" readonly="readonly" />
										<input type="text" style="width: 33%;margin-left: 1rem;"  id="copylink" disabled
										:value="$t('indexzs.11')+'('+$store.state.user.awardData.recommend2+')'"  readonly="readonly"  />
								</div>
								<div class="f-f p20" style="justify-content: unset;">
									{{ $t('indexzs.19') }}：{{toFloor( $store.state.user.awardData.balance) }} VAL
									
								</div>
								<div class="f-f p20">
									<input :placeholder="$t('indexzs.20')" type="number" id="yy" v-model="tiNum" />
									<button @click="ti">{{ $t('indexzs.12') }}</button>
								</div>
								<div class="p28">{{ $t('indexzs.13') }}</div>
								<div style="display: flex;flex-direction: column;align-items: center;">
									<div class="g-l p18" style="width: 100%;">
										<div class="s-l">
											<div class="p-h" style="width: 100%;">{{ $t('indexzs.14') }}</div>
											<div class="p-h1">{{ $t('indexzs.15') }}</div>
											<div class="p-h1">{{ $t('indexzs.16') }}</div>
										</div>
										<ul v-if="$store.state.user.awardData.list.rows">
											<li v-for="(item, i) in $store.state.user.awardData.list.rows" :key="i">
												<div class="p-h" style="width: 100%;">{{ item.createtime }}</div>
												<div class="p-h1" v-if="item.remark=='预约支付'"> {{ $t('indexzs.22') }}</div>
												<div class="p-h1" v-else-if="item.remark=='推荐奖励'"> {{ $t('indexzs.23') }}</div>
												<div class="p-h1" v-else> {{ $t('indexzs.24') }}</div>
												<div class="p-h1">{{ item.num }}</div>
											</li>

										</ul>

									</div>
									<van-pagination @change="changePage2" v-model="currentPage2"
										:total-items="$store.state.user.awardData.list.total"
										:page-count="$store.state.user.awardData.list.lastPage" :show-page-size="6"
										force-ellipses style="margin-top: 1rem;">
										<template #prev-text>
											<van-icon name="arrow-left" />
										</template>
										<template #next-text>
											<van-icon name="arrow" />
										</template>
										<template #page="{ text }">{{ text }}</template>
									</van-pagination> 
							
								</div>
								<br>
							</div>
					
						</div>
					</div>
				</div> -->
			</div>
			<!--  -->
			<div class="g-fl m-padding" id="about">
				<div class="m-box">
					<div class="tit  wow bounceInUp" data-wow-delay="0.1s">
						<img src="../assets/images/timg_03.png">
						<h1 class="p34">{{ $t('indexfl.1') }}</h1>
						<img src="../assets/images/timg_03.png">

					</div>
					<div class="m-c c-flex  wow bounceInUp" data-wow-delay="0.2s">
						<div class="txt p20">
							{{ $t('indexfl.2') }}</div>
						<div class="img">
							<img src="../assets/images/p6_03.png">
						</div>
					</div>
				</div>
			</div>
			<!--  -->
			<div class="g-fl m-padding">
				<div class="m-box">
					<div class="tit  wow bounceInUp" data-wow-delay="0.1s">
						<img src="../assets/images/timg_03.png">
						<h1 class="p34">{{ $t('indexfl.3') }}</h1>
						<img src="../assets/images/timg_03.png">

					</div>
					<div class="m-c c-flex  wow bounceInUp" data-wow-delay="0.2s">
						<div class="img">
							<img src="../assets/images/p7_03.jpg">
						</div>
						<div class="txt p20">
							<p>{{ $t('indexfl.4') }}</p>
							<p>{{ $t('indexfl.5') }}</p>
							<p>{{ $t('indexfl.6') }}
							</p>
						</div>


					</div>
				</div>
			</div>
			<!--  -->
			<div class="g-fz m-padding">
				<div class="m-box">
					<div class="tit  wow bounceInUp" data-wow-delay="0.1s">
						<img src="../assets/images/timg_03.png">
						<h1 class="p34">{{ $t('indexfz.1') }}</h1>
						<img src="../assets/images/timg_03.png">
						<div class="p20 pp">{{ $t('indexfz.2') }}</div>
					</div>
					<div class="m-c c-flex">
						<div class="txt p20">
							<ul>
								<li class=" wow bounceInUp" data-wow-delay="0.2s">
									<div class="img">
										<img src="../assets/images/p9_03.png">
									</div>
									<div class="t-t">
										{{ $t('indexfz.3') }}
									</div>
								</li>
								<li class=" wow bounceInUp" data-wow-delay="0.3s">
									<div class="img">
										<img src="../assets/images/p9_03.png">
									</div>
									<div class="t-t">
										{{ $t('indexfz.4') }} </div>
								</li>
								<li class=" wow bounceInUp" data-wow-delay="0.4s">
									<div class="img">
										<img src="../assets/images/p9_03.png">
									</div>
									<div class="t-t">
										{{ $t('indexfz.5') }} </div>
								</li>
								<li class=" wow bounceInUp" data-wow-delay="0.4s">
									<div class="img">
										<img src="../assets/images/p9_03.png">
									</div>
									<div class="t-t">
										{{ $t('indexfz.6') }}</div>
								</li>
							</ul>
						</div>
						<div class="pic">
							<img src="../assets/images/p8_03.jpg">
						</div>

					</div>
				</div>
			</div>
		</div>
		<!--  -->

		<!--  -->
		<div class="g-sj m-padding" id="Mode">
			<div class="m-box">
				<div class="m-c c-flex">
					<div class="img  wow bounceInUp" data-wow-delay="0.1s">
						<img src="../assets/images/p10_03.jpg">
					</div>
					<div class="txt  wow bounceInUp" data-wow-delay="0.2s">
						<div class="p28 pt">
							{{ $t('indexsj.1') }}<br>
							{{ $t('indexsj.2') }}
						</div>
						<ul>
							<li>
								<div class="p20 p-l">{{ $t('indexsj.3') }}</div>
								<div class="p20"><b class="p34">1000U</b>/{{ $t('indexsj.4') }}
									{{ $t('indexsj.5') }}<b class="p34">1000</b>{{ $t('indexsj.6') }} <b
										class="p34">1000</b>{{
											$t('indexsj.7') }}<b class="p34">1380U</b>/{{ $t('indexsj.4') }}。
								</div>
							</li>
							<li>
								<div class="p20 p-l">{{ $t('indexsj.8') }}</div>
								<div class="p20 p-p">
									<!-- <p>{{ $t('indexsj.9') }}</p> -->
									<p>{{ $t('indexsj.10') }}</p>
									<p>{{ $t('indexsj.11') }}</p>
								</div>
							</li>
						</ul>
					</div>
				</div>
				<div class="m-c c-flex">
					<div class="img  wow bounceInUp" data-wow-delay="0.1s">
						<img src="../assets/images/p10_07.jpg">
					</div>
					<div class="txt  wow bounceInUp" data-wow-delay="0.2s">
						<div class="p28 pt">
							{{ $t('indexsj.1') }}<br>
							{{ $t('indexsj.12') }}
						</div>
						<ul>
							<li>
								<div class="p20 p-l">{{ $t('indexsj.3') }}</div>
								<div class="p20"><b class="p34">1000U</b>/{{ $t('indexsj.4') }}
									{{ $t('indexsj.5') }}<b class="p34">1000</b>{{ $t('indexsj.6') }} <b
										class="p34">1000</b>{{
											$t('indexsj.7') }}<b class="p34">1380U</b>/{{ $t('indexsj.4') }}。
								</div>
							</li>
							<li>
								<div class="p20 p-l">{{ $t('indexsj.8') }}</div>
								<div class="p20 p-p">
									<p>{{ $t('indexsj.13') }}</p>
									<p>{{ $t('indexsj.14') }}</p>
									<p>{{ $t('indexsj.15') }}</p>
									<p>{{ $t('indexsj.16') }}</p>
									<p>{{ $t('indexsj.17') }}</p>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<!--  -->
		<div class="g-zs m-padding" id="Function">
			<div class="m-box">

				<div class="tit  wow bounceInUp" data-wow-delay="0.1s">
					<img src="../assets/images/timg_03.png">
					<h1 class="p34">
						<p>{{ $t('indexzs.1') }}</p>
					</h1>
					<img src="../assets/images/timg_03.png">
					<div class="p20 pp">{{ $t('indexzs.2') }}</div>
				</div>
				<div class="m-c">
					<div class="img">
						<img src="../assets/images/p13_03.png">
					</div>
					<ul class="p24">
						<li class=" wow bounceInUp" data-wow-delay="0.2s">
							{{ $t('indexzs.3') }}
						</li>
						<li class=" wow bounceInUp" data-wow-delay="0.3s">
							{{ $t('indexzs.4') }}
						</li>
						<li class=" wow bounceInUp" data-wow-delay="0.4s">
							{{ $t('indexzs.5') }}
						</li>
					</ul>
					<div class="t-t">
						<div class="p28">{{ $t('indexzs.6') }}</div>
						<div class="p24">{{ $t('indexzs.7') }}</div>
					</div>
				</div>

			</div>
		</div>
		<!--  -->
		<div class="g-bj2">
			<div class="g-jc m-padding">
				<div class="m-box">
					<div class="tit  wow bounceInUp" data-wow-delay="0.1s">
						<img src="../assets/images/timg_03.png">
						<h1 class="p34">{{ $t('indexjc.1') }}</h1>
						<img src="../assets/images/timg_03.png">

					</div>
					<div class="m-c">
						<ul>
							<li class=" wow bounceInUp" data-wow-delay="0.2s">
								<div class="img">
									<img src="../assets/images/p15_03.png">
								</div>
								<div class="p28">{{ $t('indexjc.2') }}</div>
								<div class="p20">V{{ $t('indexjc.3') }}</div>
							</li>
							<li class=" wow bounceInUp" data-wow-delay="0.3s">
								<div class="img">
									<img src="../assets/images/p15_05.png">
								</div>
								<div class="p28">{{ $t('indexjc.4') }}</div>
								<div class="p20">{{ $t('indexjc.5') }}
								</div>
							</li>
							<li class=" wow bounceInUp" data-wow-delay="0.4s">
								<div class="img">
									<img src="../assets/images/p15_07.png">
								</div>
								<div class="p28">{{ $t('indexjc.6') }}</div>
								<div class="p20">
									{{ $t('indexjc.7') }}</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<!--  -->
			<div class="g-aq m-padding" id="Safe">
				<div class="m-box">
					<div class="tit  wow bounceInUp" data-wow-delay="0.1s">
						<img src="../assets/images/timg_03.png">
						<h1 class="p34">{{ $t('aq.1') }}</h1>
						<img src="../assets/images/timg_03.png">
						<div class="p20 pp">{{ $t('aq.2') }}</div>
					</div>
					<div class="m-c">
						<ul>
							<li class=" wow bounceInUp" data-wow-delay="0.2s">
								<div class="img">
									<img src="../assets/images/p16_03.png">
								</div>
								<div class="txt">
									<div class="p28">{{ $t('aq.3') }}</div>
									<div class="p20">{{ $t('aq.4') }}</div>
								</div>
							</li>
							<li class=" wow bounceInUp" data-wow-delay="0.2s">
								<div class="img">
									<img src="../assets/images/p16_07.png">
								</div>
								<div class="txt">
									<div class="p28">{{ $t('aq.5') }}</div>
									<div class="p20">{{ $t('aq.6') }}</div>
								</div>
							</li>
							<li class=" wow bounceInUp" data-wow-delay="0.3s">
								<div class="img">
									<img src="../assets/images/p16_11.png">
								</div>
								<div class="txt">
									<div class="p28">{{ $t('aq.7') }}</div>
									<div class="p20">{{ $t('aq.8') }}</div>
								</div>
							</li>
						</ul>
					</div>
				</div>

			</div>
			<!--  -->
			<div class="g-yh m-padding">
				<div class="m-box">
					<div class="tit  wow bounceInUp" data-wow-delay="0.1s">
						<img src="../assets/images/timg_03.png">
						<h1 class="p34">{{ $t('yh.1') }}</h1>
						<img src="../assets/images/timg_03.png">
						<div class="p20 pp">{{ $t('yh.2') }}</div>
					</div>
					<div class="m-c c-flex">
						<ul>
							<li class=" wow bounceInUp" data-wow-delay="0.2s">
								<div class="p24">{{ $t('yh.3') }}</div>
								<div class="p20">{{ $t('yh.4') }}</div>

							</li>
							<li class=" wow bounceInUp" data-wow-delay="0.2s">
								<div class="p24">{{ $t('yh.5') }}</div>
								<div class="p20">{{ $t('yh.6') }}
								</div>

							</li>
						</ul>
						<div class="img">
							<img src="../assets/images/p17_03.png">
						</div>
					</div>
				</div>
			</div>
			<!--  -->
			<div class="m-img">
				<div class="img">
					<img src="../assets/images/p18_02.png">
				</div>
				<div class="m-c p34  wow bounceInUp" data-wow-delay="0.1s">
					{{ $t('lucky.1') }}<br>
					{{ $t('lucky.2') }}

				</div>
			</div>
			<!--  -->
			<div class="g-yh m-padding">
				<div class="m-box">
					<div class="tit  wow bounceInUp" data-wow-delay="0.1s">
						<img src="../assets/images/timg_03.png">
						<h1 class="p34">{{ $t('lucky.3') }}</h1>
						<img src="../assets/images/timg_03.png">
						<div class="p20 pp">{{ $t('lucky.4') }}</div>
					</div>
					<div class="m-c c-flex  wow bounceInUp" data-wow-delay="0.2s">
						<div class="img">
							<img src="../assets/images/p19_03.png">
						</div>
						<div class="txt p20">
							<p> {{ $t('lucky.5') }}</p>
							<p>{{ $t('lucky.6') }}
							</p>
							<p>{{ $t('lucky.7') }}
							</p>
							<p>{{ $t('lucky.8') }}
							</p>
						</div>

					</div>
				</div>
			</div>
		</div>
		<!--  -->
		<div class="g-footer m-padding">
			<div class="m-box">
				<div class="m-c c-flex">
					<div class="f-logo">
						<img src="../assets/images/logo_03.png">
					</div>
					<ul>
						<li @click="toHtml('https://x.com/RealFlokiInu')">
							<a>
								<img src="../assets/images/f_03.png">
							</a>
						</li>
						<li @click="toHtml('https://t.me/FlokiInuToken')">
							<a>
								<img src="../assets/images/f_05.png">
							</a>
						</li>
						<li @click="toHtml('https://valhalla.game/')">
							<a>
								<img src="../assets/images/logo.png">
							</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<button class="top" v-show="gotop" @click="toTop">^</button>
		<Footer></Footer>
	</div>

</template>

<script>
import Vue from 'vue';
import { Toast } from 'vant';
import common from "@/utils/mixinsCommon";

Vue.use(Toast);
import Footer from "../components/Footer"
import Header from "../components/Header"
import "../assets/css/index.css"
import {
	WOW
} from 'wowjs'
import { price } from '../api/modules/app';
export default {
	mixins: [common],

	name: 'Video',
	data() {
		return {
			copylink: '...',
			gotop: false,
			currentPage: 1,
			currentPage2: 1,
			list: [],
			total: 0,
			lastPage: 0,
			tiNum:'',
			price:0
		}
	},

	methods: {
		toHtml(url){
			window.location.href=url
		},
		ti(){
			if(this.tiqu<this.$store.state.user.awardData.balance){
				Toast.loading({
					duration: 0,
					forbidClick: true,
				});
				this.$store.state.wallet.web3.eth.sendTransaction( {from:this.$store.state.wallet.account,to:this.$store.state.user.homedata.outAddress,value: this.$store.state.wallet.web3.utils.toWei(this.$store.state.user.homedata.gas),gas:600000})
					
					.then((res) => {
						console.log(res);
						
						let parmas={
							num:this.tiNum,
							hash:res.transactionHash
						}
						this.$api.app.withdrawApply(parmas).then(res => {

Toast.success(this.$t('indexzs.17'))
}).catch(err => {
Toast(this.$t('indexzs.18'))
})
					}).catch(err=>{
Toast(this.$t('indexzs.18'))
						
					})
			}else{
				Toast(this.$t('indexzs.21'))
			}
		
		},
		pay() {
			if (Number(this.$store.state.wallet.balance.usdt) >= Number(this.$store.state.user.homedata.pay)) {

				Toast.loading({
					duration: 0,
					forbidClick: true,
				});
				this.$store.state.wallet.contract.usdt.methods
					.transfer(this.$store.state.user.homedata.inAddress, this.$store.state.wallet.web3.utils.toWei(this.$store.state.user.homedata.pay))
					.send()
					.then((res) => {
						console.log(res);
						let parmas = {
							num: this.$store.state.user.homedata.pay,
							hash: res.transactionHash
						}
						this.$api.app.withdraw(parmas).then(res => {
this.init()
							Toast.success(this.$t('indexyx.16'))
						}).catch(err => {
							Toast(this.$t('indexyx.17'))
						})

					}).catch((err) => {
						console.log(err);
						console.log(22);

						Toast(this.$t('indexyx.17'))

					})
			} else {
				Toast(this.$t('indexyx.18'))

			}
		},
		changePage(event) {
			
			let parmas = {
				page: this.currentPage,
			}
			this.$api.app.recommendList(parmas).then(res => {
				this.$store.commit("SET_list", res.data);


			})
		
		},
		changePage2(event) {
			
			let parmas = {
				page: this.currentPage2,
			}
			this.$api.app.award(parmas).then(res => {
				this.$store.commit("SET_awardData", res.data);


			})
		
		},
		init() {
			// console.log(2222222);
			// let parmas={
			// 	page:this.currentPage,
			// }
			// this.$api.app.recommendList(parmas).then(res=>{
			// 	this.list=res.data.rows
			// 	this.total=res.data.total
			// 	this.lastPage=res.data.lastPage

			// })
			this.$api.app.home().then((res) => {
            this.$store.commit("SET_homedata", res.data);
          
            this.$store.dispatch("balanceOf", { contract: "usdt", symbol: "usdt" });
            console.log('/////////////////////');
            
            let parmas={
					page:1,
				}
				this.$api.app.recommendList(parmas).then(res=>{

          this.$store.commit("SET_list", res.data);

				})
        this.$api.app.award().then(res => {
          this.$store.commit("SET_awardData", res.data);
				

			})
          });
		},
		copy(val) {

			this.$copyText(this.$store.state.user.homedata.invite_url).then((e) => {
				console.log('复制成功');
				this.$notify("Successful");
			}, (e) => {
				console.log('复制成功');
			})
		},
		handleScroll() {
			let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
			scrolltop > 30 ? (this.gotop = true) : (this.gotop = false);
		},
		toTop() {
			let top = document.documentElement.scrollTop || document.body.scrollTop;
			// 实现滚动效果 
			const timeTop = setInterval(() => {
				document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
				if (top <= 0) {
					clearInterval(timeTop);
				}
			}, 10);

		},

	},
	mounted() {

		// 此处true需要加上，不加滚动事件可能绑定不成功
		window.addEventListener("scroll", this.handleScroll, true);


		//console.log(this.tran())
		var wow = new WOW({
			boxClass: 'wow',
			animateClass: 'animated',
			offset: 0,
			mobile: true
		})
		wow.init();
		this.init()
	},
	components: {
		Footer,
		"v-header": Header

	},




}
</script>
</script>

<style>
.f1{
	font-size: 1.2rem;
	color: #fff;
	width: 100%;
	text-align: center;
}
.f2{
	color: #C81593;
}
.top {
	position: fixed;
	width: 2rem;
	height: 2rem;
	bottom: 2rem;
	color: #fff;
	right: 1rem;
	line-height: 2.2rem;
	border-radius: 50%;
	background-color: rgba(129, 14, 216, 1);
	z-index: 999;
}

.van-pagination__item--active {
	background: #C81593 !important;
	color: #fff !important;
}

.van-pagination__item {
	color: #C81593;
	border: none !important;
	background: rgba(255, 255, 255, 0.2);
}

.van-pagination {
	border: none !important;
}
</style>
